// src/locales/competition3-i18n.ts
import {createInstance} from 'i18next';
import {initReactI18next} from 'react-i18next';

import ar from './scoped/ar.json';
import en from './scoped/en.json';
import fa from './scoped/fa.json';

const scopedI18n = createInstance();

scopedI18n.use(initReactI18next).init({
	resources: {
		fa: {translation: fa},
		en: {translation: en},
		ar: {translation: ar}
	},
	lng: 'fa', // default language
	fallbackLng: 'fa',
	interpolation: {escapeValue: false},
	react: {useSuspense: false}
});

export default scopedI18n;
